<template>
  <v-menu v-bind="$attrs" v-on="$listeners" :value="value" @input="v => $emit('input', v)">
    <template v-slot:default="{ attrs, on }">
      <slot v-bind="{ attrs, on }"></slot>
    </template>
    <template v-slot:activator="{ attrs, on }">
      <slot name="activator" v-bind="{ attrs, on }"></slot>
    </template>
  </v-menu>
</template>

<script>
import uuid4 from '@/utils/uuid.js';

export default {
  name: 'menu-scroll-lock',

  props: { value: Boolean },

  destroyed() {
    this.$delete(this.global.scrollLock, this.uuid);
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.uuid ||= uuid4();
        this.$set(this.global.scrollLock, this.uuid, v);
      }
    }
  }
}
</script>
